module.exports = __webpack_public_path__ + "img/go.859f0bcb.png";